import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import fromPairs from 'lodash/fromPairs';
import flattenDeep from 'lodash/flattenDeep';
import {
  updateLocationDetails,
  updateSearchCriteria,
  getMatchingCategories,
  getMatchingFilters,
  setCampaignDetails,
} from '@americanexpress/one-maps-base';
/** *
 * @produces State Updates
 * @param store
 *
 * When user enters using a URL, this onEnter hook will be invoked.
 * It reads the `pathname` to parse Path params
 * For Ex: country=US/near=Phoenix,AZ,85085/cl=33.7248,-112.0889 will become
 * { country:'US', near='Phoenix,AZ,85085', cl=33.7248,-112.0889}
 * These path params will be used to form `locationDetails` object and disptached to store
 * It also reads `queryParams` to read version and bounding box attributes
 */

const parseUrlsForParams = (urlPattern) => fromPairs(urlPattern.split('/').map((value) => value.split('=', 2)));

// eslint-disable-next-line complexity
const checkTheUrlParams = (store) => { // eslint-disable-line no-unused-vars
  const { dispatch } = store;
  // eslint-disable-next-line complexity
  return async (nextState, replace, callback) => {
    try {
      const { location: { pathname, query } } = nextState;
      const queryParams = query;
      const pathName = pathname;
      const usUrls = [
        '/us/shop-small',
        '/us/small-business/shop-small/maps',
        '/shopsmall',
      ];
      const ukUrl = [
        '/shopsmalluk',
        '/ukshopsmall',
        '/gb/shop-small',
      ];

      const auUrl = [
        '/aushopsmall',
        '/au/shop-small',
      ];

      const sgUrl = [
        '/sgmemberfave',
        '/sg/member-favourites',
      ];

      const caUrl = ['/shopsmallcanada',
        '/ca/cards-welcome',
      ];

      const mxURl = ['/mx/shop-small'];

      const urlPatterns = flattenDeep([usUrls, ukUrl, auUrl, sgUrl, caUrl, mxURl]);

      const getCountryCode = (pathNameVal) => {
        if (ukUrl.findIndex((url) => pathNameVal.toLowerCase().includes(url)) > -1) {
          return {
            country: 'GB',
            near: 'London, UK',
            cl: '51.5569879,-0.14117910000004485',
          };
        }
        if (caUrl.findIndex((url) => pathNameVal.toLowerCase().includes(url)) > -1) {
          return {
            country: 'CA',
            near: 'Toronto, ON',
            cl: '43.653226,-79.38318429999998',
          };
        }
        if (auUrl.findIndex((url) => pathNameVal.toLowerCase().includes(url)) > -1) {
          return {
            country: 'AU',
            near: 'Sydney NSW, Australia',
            cl: '-33.8688197,151.20929550000005',
          };
        }
        if (sgUrl.findIndex((url) => pathNameVal.toLowerCase().includes(url)) > -1) {
          return {
            country: 'SG',
            near: 'Pulau Ujong, Singapore',
            cl: '1.3644337,103.77526339999997',
          };
        }
        if (mxURl.findIndex((url) => pathName.toLowerCase().includes(url)) > -1) {
          return {
            country: 'MX',
            near: 'Mexico City, CDMX',
            cl: '19.2464696,-99.10134979999998',
          };
        }
        return {
          country: 'US',
          near: 'New York, NY',
          cl: '40.7127837,-74.00594130000002',
        };
      };

      const getLocale = (pathNameVal) => {
        if (usUrls.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'en-us';
        }
        if (ukUrl.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'en-gb';
        }
        if (auUrl.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'en-au';
        }
        if (caUrl.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'en-ca';
        }
        if (sgUrl.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'en-sg';
        }
        if (mxURl.findIndex((url) => pathNameVal.toLowerCase() === url) > -1) {
          return 'es-mx';
        }
        return 'en-us';
      };

      if (urlPatterns.findIndex((url) => pathName && pathName.toLowerCase().startsWith(url)) > -1) {
        const pathParams = parseUrlsForParams(pathName);
        const arrayOfKeys = Object.keys(pathParams);

        // eslint-disable-next-line max-len
        const nearValue = isEmpty(pathParams.near) ? getCountryCode(pathName).near : pathParams.near;
        const locationDetails = {
          country: !isEmpty(pathParams.cl) && getCountryCode(pathName).country,
          near: isEmpty(pathParams.near) && getCountryCode(pathName).near,
          city: !isEmpty(pathParams.cl) && pathParams.near.split(',').length > 1 ? pathParams.near.split(',')[0] : null,
          state: !isEmpty(pathParams.cl) && pathParams.near.split(',').length > 1 ? pathParams.near.split(',')[1] : null,
          postalCode: !isEmpty(pathParams.cl) && nearValue.split(',').length > 2 ? nearValue.split(',')[2].replace('-', ' ') : null,
          lat: pathParams.cl && pathParams.cl.split(',').length > 1 ? pathParams.cl.split(',')[0] : null,
          lng: pathParams.cl && pathParams.cl.split(',').length > 1 ? pathParams.cl.split(',')[1] : null,
          neLat: queryParams.ne && queryParams.ne.split(',').length > 1 ? queryParams.ne.split(',')[0] : null,
          neLng: queryParams.ne && queryParams.ne.split(',').length > 1 ? queryParams.ne.split(',')[1] : null,
          swLat: queryParams.sw && queryParams.sw.split(',').length > 1 ? queryParams.sw.split(',')[0] : null,
          swLng: queryParams.sw && queryParams.sw.split(',').length > 1 ? queryParams.sw.split(',')[1] : null,
          formattedAddress: pathParams.near && pathParams.near.replace(/-/g, ' '),

        };

        if (pathParams.token) {
          locationDetails.token = pathParams.token;
        }
        updateLocationDetails(pickBy(locationDetails, identity))(dispatch);

        let categoryValue = pathParams.cat;
        if (categoryValue) {
          categoryValue = categoryValue.replace('Member-Favorites', 'Member-Favorite');
          categoryValue = categoryValue.replace('Member-Favourites', 'Member-Favorite');
          categoryValue = categoryValue.replace('Newly-Added', 'New-Merchant');
          categoryValue = categoryValue.replace('Eating-and-Drinking', 'Dining');
        }
        const searchCriteria = {
          searchTerm: !isEmpty(pathParams.name) ? pathParams.name && pathParams.name.replace(/-/g, ' ') : pathParams.key && pathParams.key.replace(/-/g, ' '),
          exactNameSearch: !isEmpty(pathParams.name),
          searchCategories: getCountryCode(pathName).country === 'US' ? getMatchingCategories([categoryValue && categoryValue.split('+'), 'Shop-Small']) : getMatchingCategories(categoryValue && categoryValue.split('+')),
          searchFilters: [],
          intlink: queryParams.intlink,
          extlink: queryParams.extlink,
          mid: pathParams.mid,
          'account-key': queryParams['account-key'],
        };

        updateSearchCriteria(pickBy(searchCriteria, identity))(dispatch);
        const campaignSelected = {
          country: getCountryCode(pathName).country,
          version: isEmpty(queryParams.ver) && getCountryCode(pathName).country === 'US' ? 'shopsmall' : queryParams.ver, // TODO: Check for valid version here
          rewriteUrl: true,
          // isGuides: arrayOfKeys && arrayOfKeys.indexOf('guides') !== -1,
          isOnline: arrayOfKeys && arrayOfKeys.indexOf('online') !== -1,
          isOffers: arrayOfKeys && arrayOfKeys.indexOf('offers') !== -1,
          // guideName: arrayOfKeys && arrayOfKeys[arrayOfKeys.indexOf('guides') + 1],
          locale: isEmpty(queryParams.lang) ? getLocale(pathName) : queryParams.lang,
        };
        setCampaignDetails(pickBy(campaignSelected, identity))(dispatch);
      } else {
        const locationDetails = {
          country: queryParams && queryParams.country,
          near: queryParams && queryParams.near,
          city: queryParams && queryParams.near && queryParams.near.split(',').length > 1 ? queryParams.near.split(',')[0] : null,
          state: queryParams && queryParams.near && queryParams.near.split(',').length > 1 ? queryParams.near.split(',')[1] : null,
          postalCode: queryParams && queryParams.near && queryParams.near.split(',').length > 2 ? queryParams.near.split(',')[2].replace('-', ' ') : null,
          lat: queryParams && queryParams.cl && queryParams.cl.split(',').length > 1 ? queryParams.cl.split(',')[0] : null,
          lng: queryParams && queryParams.cl && queryParams.cl.split(',').length > 1 ? queryParams.cl.split(',')[1] : null,
          neLat: queryParams && queryParams.ne && queryParams.ne.split(',').length > 1 ? queryParams.ne.split(',')[0] : null,
          neLng: queryParams && queryParams.ne && queryParams.ne.split(',').length > 1 ? queryParams.ne.split(',')[1] : null,
          swLat: queryParams && queryParams.sw && queryParams.sw.split(',').length > 1 ? queryParams.sw.split(',')[0] : null,
          swLng: queryParams && queryParams.sw && queryParams.sw.split(',').length > 1 ? queryParams.sw.split(',')[1] : null,
          formattedAddress: queryParams && queryParams.near && queryParams.near.replace(/-/g, ' '),

        };
        if (queryParams && queryParams.token) {
          locationDetails.token = queryParams.token;
        }
        updateLocationDetails(pickBy(locationDetails, identity))(dispatch);

        const searchCriteria = {
          searchTerm: !isEmpty(queryParams && queryParams.name)
            ? decodeURIComponent(queryParams && queryParams.name)
            : queryParams && queryParams.key && decodeURIComponent(queryParams && queryParams.key),
          exactNameSearch: !isEmpty(queryParams && queryParams.name),
          searchCategories: queryParams && queryParams.cat ? getMatchingCategories(queryParams.cat.split(',')) : [],
          searchFilters: queryParams && queryParams.filter ? getMatchingFilters(queryParams.filter.split(',')) : [],
          intlink: queryParams && queryParams.intlink,
          extlink: queryParams && queryParams.extlink,
          mid: queryParams && queryParams.mid,
          'account-key': queryParams && queryParams['account-key'],
        };
        updateSearchCriteria(pickBy(searchCriteria, identity))(dispatch);
        const campaignSelected = {
          country: queryParams && isEmpty(queryParams.country) ? 'US' : queryParams && queryParams.country,
          version: queryParams && isEmpty(queryParams.version) ? 'default' : queryParams && queryParams.version, // TODO: Check for valid version here
        };
        setCampaignDetails(pickBy(campaignSelected, identity))(dispatch);
      }
      return callback();
    } catch {
      return callback();
    }
  };
};

export default checkTheUrlParams;
